export default __webpack_public_path__ + "static/media/(79).e2af1e3e.jpg";